import React, { useState, Component } from 'react';
import { Send, Phone, Globe, Briefcase, FileText, Mail, User } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactForm({
  title = 'Start Your Project',
  id = 'contact-form'
}: {
  title?: string;
  id?: string;
}) {
  const [formData, setFormData] = useState({
    fullName: '',
    website: '',
    businessNature: '',
    projectDetails: '',
    email: '',
    phone: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hi, I'm ${formData.fullName} from ${formData.website || 'No Website'}. 
Business Nature: ${formData.businessNature}
Project Details: ${formData.projectDetails}
Email: ${formData.email}
Phone: ${formData.phone}`;
    const whatsappUrl = `https://wa.me/447921876472?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id={id} className="py-16 bg-slate-900 relative overflow-hidden" data-id="element-46">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-47">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-red-600 rounded-full blur-3xl" data-id="element-48"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-red-800 rounded-full blur-3xl" data-id="element-49"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 shadow-2xl" data-id="element-51">
          <div className="text-center mb-8" data-id="element-52">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-53">{title}</h2>
            <p className="text-slate-400" data-id="element-54">
              Fill out the form below to discuss your project on WhatsApp
              instantly.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-55">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-56">
              <div className="space-y-2" data-id="element-57">
                <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-58">
                  <User className="w-4 h-4 text-red-500" data-id="element-59" /> Full Name
                </label>
                <input required type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none" placeholder="John Doe" data-id="element-60" />
              </div>

              <div className="space-y-2" data-id="element-61">
                <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-62">
                  <Globe className="w-4 h-4 text-red-500" data-id="element-63" /> Website
                </label>
                <input type="text" name="website" value={formData.website} onChange={handleChange} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none" placeholder="yourdomain.com" data-id="element-64" />
              </div>

              <div className="space-y-2" data-id="element-65">
                <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-66">
                  <Briefcase className="w-4 h-4 text-red-500" data-id="element-67" /> Business Nature
                </label>
                <input required type="text" name="businessNature" value={formData.businessNature} onChange={handleChange} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none" placeholder="E-commerce, Real Estate, etc." data-id="element-68" />
              </div>

              <div className="space-y-2" data-id="element-69">
                <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-70">
                  <Phone className="w-4 h-4 text-red-500" data-id="element-71" /> Phone Number
                </label>
                <input required type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none" placeholder="+1 234 567 890" data-id="element-72" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-73">
              <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-74">
                <Mail className="w-4 h-4 text-red-500" data-id="element-75" /> Email Address
              </label>
              <input required type="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none" placeholder="john@example.com" data-id="element-76" />
            </div>

            <div className="space-y-2" data-id="element-77">
              <label className="text-sm font-medium text-slate-300 flex items-center gap-2" data-id="element-78">
                <FileText className="w-4 h-4 text-red-500" data-id="element-79" /> Project Details
              </label>
              <textarea required name="projectDetails" value={formData.projectDetails} onChange={handleChange} rows={4} className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none resize-none" placeholder="Tell us about your requirements..." data-id="element-80" />
            </div>

            <button type="submit" className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white font-bold py-4 rounded-lg shadow-lg hover:shadow-red-500/25 transition-all flex items-center justify-center gap-2 group" data-id="element-81">
              <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-82" />
              Send to WhatsApp
            </button>
          </form>
        </motion.div>
      </div>
    </section>;
}